import validate from './validate';

const valueValidators = {
  isFloatNumber: value => value !== '' && !isNaN(parseFloat(value)),
  maxStake: value => parseFloat(value) <= 10000
};

const valueForSingleBet = Object.assign({}, valueValidators, {
  minStakeSingle: value => parseFloat(value) >= 0.25
});

const valueForMultipleBet = Object.assign({}, valueValidators, {
  minStakeMultiple: value => parseFloat(value) >= 0.1
});

const validationErrors = {
  isFloatNumber: 'Enter a valid stake',
  maxStake: 'Maximum stake is £10,000',
  minStakeSingle: 'Minimum stake is £0.25',
  minStakeMultiple: 'Minimum stake is £0.10'
};

export const checkStakeValueSingle = (
  stake => validate(stake, valueForSingleBet, validationErrors)
);

export const checkStakeValueMultiple = (
  stake => validate(stake, valueForMultipleBet, validationErrors)
);

export default { checkStakeValueSingle, checkStakeValueMultiple };
